export default {
  name: 'Company',
  props: [
    'address',
    'contact',
    'name',
    'primaryColor',
    'url'
  ]
}



// WEBPACK FOOTER //
// ./src/assets/pages/Company/Company.js